import {fetchRemoteResult} from "./api-util";
import securityApi from "../Util/security";

const endpoint = '/DmVisualizer/';

let _divisionId;

export default {
    setDivisionId(divisionId) {
        _divisionId = divisionId;
    },
    
    listScenarios(){
        return fetchRemoteResult(`${endpoint}ListIndex?divisionId=${_divisionId || ''}`);
    },
    getTemplatesByScenario(id) {
        return fetchRemoteResult(`${endpoint}GetScenarioTemplates/${id}?divisionId=${_divisionId || ''}`);
    },
    getCustomerContactEmail(){
        return fetchRemoteResult(`${endpoint}GetCustomerContactEmail`);
    },
    listActiveBatches(){
        return fetchRemoteResult(`${endpoint}ListActiveBatches?divisionId=${_divisionId || ''}`);
    },
    listHistoricalBatches(){
        return fetchRemoteResult(`${endpoint}ListHistoricalBatches?divisionId=${_divisionId || ''}`);
    },
    activateBatches(batchIds){
        return fetchRemoteResult(`${endpoint}ActivateBatch?divisionId=${_divisionId || ''}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({batchIds: batchIds})
        });
    },
    deactivateBatches(batchIds){
        return fetchRemoteResult(`${endpoint}DeactivateBatch?divisionId=${_divisionId || ''}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({batchIds: batchIds})
        });
    },
    changeInfo(model){
        return fetchRemoteResult(`${endpoint}changeInfo?divisionId=${_divisionId || ''}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(model)
        });
    },
    uploadLogo(logo) {
        const formData = new FormData();
        formData.append('file', logo);

        return fetchRemoteResult(`${endpoint}UploadLogo`, {
            method: 'POST',
            body: formData
        });
    },
    acceptScenarioSelection(scenarioIds){
        return fetchRemoteResult(`${endpoint}AcceptScenarioSelection?divisionId=${_divisionId || ''}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({scenarioIds: scenarioIds})
        });
    },
    formatTemplatePreviewUrl(templateId){
        return `${endpoint}TemplatePreview/${templateId}?divisionId=${_divisionId || ''}`;
    },
    formatDashboardUrl() {
        return `${endpoint}Dashboard?divisionId=${_divisionId || ''}`;
    },
    validateWritePermission(){
        return this.validatePermission(
            securityApi.PermissionGrantTypes.Write
        );
    },
    validateDeletePermission(){
        return this.validatePermission(
            securityApi.PermissionGrantTypes.Delete
        );
    },
    validatePermission(permissionGrantType){
        return securityApi.validatePermission(
            securityApi.Permissions.DmVisualizer,
            permissionGrantType
        );
    },
    endpoint
};
